module.exports = __webpack_public_path__ + "static/media/290799.6a018193.png";